module.exports = __webpack_public_path__ + "static/media/Artboard5.77e1f82f.jpg";